// src/Akhdar/AkhdarDetail.js
import React, { useState } from "react";
import "./akhdar.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function AkhdarDetail() {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <nav className="navbar">
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <h1>Ziad Aly</h1>
        </Link>
      </nav>
      <div className="akhdarproject-detail notion-style">
        <div className="akhdar-video-container">
          <video
            controls
            muted
            width="100%"
            src={`${process.env.PUBLIC_URL}/./Akhdar.mov`}
          />
        </div>
        <div className="detail-content">
          <div className="text-container">
            <h1>Akhdar</h1>
            <h2>Project Overview</h2>
            <div>
              <p>
                The AKHDAR Impact Marketplace & Carbon Offset Platform was
                initiated to both finance ongoing operations and establish
                strategic access to the Saudi Arabian investment ecosystem. The
                opportunity originated through a networking introduction between
                the business development lead and key stakeholders, prior to my
                direct involvement. At the outset, the project lacked clear
                requirements, execution structure, and technical ownership,
                creating risks around scope, delivery, and budget
                control—particularly critical for a sustainability-focused
                product targeting SMEs and individuals across Saudi Arabia and
                the wider MENA region.
                <span
                  onClick={handleToggle}
                  style={{ color: "blue", cursor: "pointer" }}
                >
                  {expanded ? "" : "...more"}
                </span>
              </p>

              {expanded && (
                <>
                  <h3>Execution & Ownership</h3>
                  <p>
                    Upon joining, I assumed full technical execution ownership,
                    translating a high-level vision into a structured MVP
                    delivery plan. This included clarifying requirements,
                    defining scope, setting timelines, establishing delivery
                    processes, hiring and coordinating the technical team, and
                    negotiating budgets to align ambition with feasibility. The
                    outcome was a clearly defined MVP roadmap for a bilingual
                    (Arabic/English) carbon marketplace and calculator platform,
                    integrating local payment gateways and third-party APIs, and
                    designed to support Saudi Vision 2030 sustainability goals
                    while remaining scalable for future regional growth.
                  </p>
                </>
              )}
            </div>
            <div>
              <h2>Technology</h2>
              <ul>
                <li>
                  <strong>Backend:</strong> Node.js, TypeScript
                </li>
                <li>
                  <strong>Frontend:</strong> React.js, TypeScript
                </li>
                <li>
                  <strong>Animations:</strong> GSAP
                </li>
                <li>
                  <strong>AWS:</strong> DynamoDB, Lambda Functions, API Gateway,
                  S3, CloudFront
                </li>
              </ul>
              <h2>Team</h2>
              <a
                href="https://www.linkedin.com/in/yasser-mohammed-aljibaly/"
                target="_blank"
                style={{ color: "inherit" }}
                rel="noopener noreferrer"
              >
                Yasser Mohammed - Co-owner
              </a>
              <p>Youssef el-khattab - Backend Engineer/Cloud</p>
              <a
                href="https://www.linkedin.com/in/thomasashraf/"
                target="_blank"
                style={{ color: "inherit" }}
                rel="noopener noreferrer"
              >
                Thomas Ashraf - Frontend Engineer
              </a>
            </div>
            <h2>Status</h2>
            <p style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  backgroundColor: "green",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "8px",
                }}
              ></span>
              Delivered on the agreed timeline, from idea to platform, live and
              operational with no ongoing data exposure.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AkhdarDetail;
